// extracted by mini-css-extract-plugin
module.exports = {"TabLinks":"TabLinks_TabLinks__2YS7S","TabLink":"TabLinks_TabLink__1lUqv","Active":"TabLinks_Active__3pQuM"};